import api from './api'

export const bannersService = {
  getAll: async (params = {}) => {
    const res = await api.get('/banners/all', { params })
    return res.data
  },

  getActive: async () => {
    const res = await api.get('/banners')
    return res.data
  },

  getById: async (id) => {
    const res = await api.get(`/banners/${id}`)
    return res.data.data
  },

  create: async (data) => {
    const res = await api.post('/banners', data)
    return res.data.data
  },

  update: async (id, data) => {
    const res = await api.put(`/banners/${id}`, data)
    return res.data.data
  },

  delete: async (id) => {
    await api.delete(`/banners/${id}`)
  },

  toggle: async (id) => {
    const res = await api.patch(`/banners/${id}/toggle`)
    return res.data.data
  },

  reorder: async (bannerIds) => {
    await api.patch('/banners/reorder', { bannerIds })
  },
}
